import { AttendanceFlag } from '@/services/attendance/types';
import { format } from 'date-fns';

export const exportAttendanceFlagsToCSV = (flags: AttendanceFlag[]) => {
  // Define CSV headers
  const headers = [
    'Employee Name',
    'Employee Email',
    'Date',
    'Time',
    'Flag Type',
    'Severity',
    'Deviation (min)',
    'Scheduled Time',
    'Actual Time',
    'Flag Reason',
    'Resolution Status',
    'Resolution Note',
    'Resolved By',
    'Resolved At',
    'Entry ID',
    'Profile ID',
  ];

  // Convert flags to CSV rows
  const rows = flags.map((flag) => {
    const employeeName = flag.profile
      ? `${flag.profile.first_name || ''} ${flag.profile.last_name || ''}`.trim() || 'N/A'
      : 'N/A';
    const employeeEmail = flag.profile?.email || 'N/A';
    const date = format(new Date(flag.event_date), 'yyyy-MM-dd');
    const time = flag.event_time || flag.scheduled_time || 'N/A';
    const flagType = flag.flag_type.replace(/_/g, ' ');
    const severity = flag.flag_severity.toUpperCase();
    const deviation = flag.deviation_minutes?.toString() || 'N/A';
    const scheduledTime = flag.scheduled_time || 'N/A';
    const actualTime = flag.event_time || 'N/A';
    const flagReason = flag.flag_reason || 'N/A';
    const resolutionStatus = flag.resolved_at ? 'Resolved' : 'Open';
    const resolutionNote = flag.resolution_note || 'N/A';
    const resolvedBy = flag.resolved_by || 'N/A';
    const resolvedAt = flag.resolved_at
      ? format(new Date(flag.resolved_at), 'yyyy-MM-dd HH:mm:ss')
      : 'N/A';
    const entryId = flag.time_entry_id || 'N/A';
    const profileId = flag.profile_id;

    return [
      employeeName,
      employeeEmail,
      date,
      time,
      flagType,
      severity,
      deviation,
      scheduledTime,
      actualTime,
      flagReason,
      resolutionStatus,
      resolutionNote,
      resolvedBy,
      resolvedAt,
      entryId,
      profileId,
    ];
  });

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map((row) =>
      row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')
    ),
  ].join('\n');

  // Create blob and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  const timestamp = format(new Date(), 'yyyy-MM-dd_HH-mm-ss');
  
  link.setAttribute('href', url);
  link.setAttribute('download', `attendance-flags-${timestamp}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
